import { call, takeLatest } from "redux-saga/effects";
import * as MedicationApi from "api/medication.api";
import {
  rejectPromiseAction,
  resolvePromiseAction,
} from "@adobe/redux-saga-promise";
import {
  MEDICATION_SEARCH_TRIGGER,
  MedicationSearchAction,
} from "store/medication/medication.types";
import { MedicationSearchResult } from "model/medication-search-result.model";

export function* medicationSaga() {
  yield takeLatest(MEDICATION_SEARCH_TRIGGER, searchMedication);
}

function* searchMedication(action: MedicationSearchAction) {
  const { searchText } = action.payload;
  try {
    const medicationResults: MedicationSearchResult[] = yield call(
      MedicationApi.searchMedication,
      searchText
    );
    yield call(resolvePromiseAction, action, medicationResults);
  } catch (e) {
    yield call(rejectPromiseAction, action, e);
  }
}
